import Storage from '../utilities/storage.js';
import {createHeader, createParagraph } from '../utilities/elements.js';
import moment from 'moment';
import { addSpinner, removeSpinner } from '../utilities/spinner.js'; //ui js

function Reservation ( reservationId, wcProductId, created, eventTypeId, check, checkDetails, customer, event, eventReservation, eventReservationLink, status, wcEventTitle, induction ) {

  this.reservationId = reservationId;
  this.wcProductId = wcProductId;
  this.created = created;
  this.eventTypeId = eventTypeId;

  this.check = check;
  this.checkDetails = checkDetails;
  this.customer = customer;
  this.event = event;
  this.eventReservation = eventReservation;
  this.eventReservationLink = eventReservationLink;
  this.status = status;
  this.wcEventTitle = wcEventTitle;
  this.induction = induction;

}

Reservation.prototype.setStatusCancelled = function() {
  //set status
  this.status = 'cancelled';
  //set in local storage
  let storage = new Storage();
  let reservationStore = storage.retrieve('reservations');
  reservationStore.items[this.reservationId].status = 'cancelled';
  storage.store(this.reservationId, 'reservations', this);

  return true;
}

Reservation.prototype.displaySummary = function ( targetEl ) {

  console.log(this);

  let eventTitle = ( this.induction ) ? this.wcEventTitle + ' + Inductions' : this.wcEventTitle ;
  targetEl.appendChild(createHeader( 'h2', eventTitle ));
  let startTimeMoment = moment( this.eventReservation.startTime );
  let startDateDisplay = startTimeMoment.format( 'dddd, Do MMMM YYYY' );
  let startTimeDisplay = startTimeMoment.format( 'H:mm' );
  if( this.induction ){
    let inductionStartMoment = moment( this.induction.startTime );
    startTimeDisplay += ' (Inductions at ' + inductionStartMoment.format('H:mm') + ')';
  }
  let startDate = createParagraph( startDateDisplay, 'reservation-date' );
  let startTime = createParagraph( startTimeDisplay, 'reservation-time' );

  targetEl.appendChild( startDate );
  targetEl.appendChild( startTime );

  removeSpinner( targetEl );

};


export default Reservation;
